import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { ApiResponseValue, ApiResponse } from '@/types/validateContainerBlType';
import { titularRut } from '@/pages/CustomerRegistration/titularRut';

export type Validated = {
  oidLiquidacion: number;
  rut: string;
  containers: unknown[];
};

export const scheduleImportFCL = async (
  query: Validated
): Promise<ApiResponseValue> => {
  try {
    await titularRut({ rut: query.rut });
    const res = await apiClient.post<ApiResponse>(Endpoints.VisitsSettlement, {
      oidLiquidacion: query.oidLiquidacion,
    });
    if (!res.data.isSuccess) {
      throw new Error(res.data.value.mensaje);
    } else {
      const sheduleRecaudacion = await apiClient.post<ApiResponse>(
        Endpoints.SheduleRecaudacion,
        {
          oidLiquidacion: query.oidLiquidacion,
        }
      );
      if (!sheduleRecaudacion.data.isSuccess) {
        throw new Error(sheduleRecaudacion.data.value.mensaje);
      } else {
        const res3 = await apiClient.post<ApiResponse>(
          Endpoints.ScheduleLiquidation,
          {
            oidLiquidacion: query.oidLiquidacion,
          }
        );
        if (!res3.data.isSuccess) {
          throw new Error(res3.data.value.mensaje);
        }
      }
    }
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
